// Relative "X ago" formatter for Premium Components — the canonical verbose form
// ("just now" / "N min ago" / "N h ago" / "N d ago" / "N w ago" / "N mo ago" /
// "N y ago"). Pure: pass the current epoch ms (from `useNow()`) as `now`, so the
// label re-renders live as time advances.
//
// Transcribed VERBATIM from the per-slot `ACRelTime` it replaces (Submissions /
// Leaderboard / Discussion) — same Math.max(0, …) clamp, same Math.floor buckets,
// same thresholds and label strings — so it is a behaviour-preserving drop-in.
// Null / unparseable input → "—"; a future timestamp clamps to "just now".
export function relTime(iso: string | null | undefined, now: number): string {
  if (!iso) return '—';
  const t = Date.parse(iso);
  if (isNaN(t)) return '—';
  const s = Math.max(0, (now - t) / 1000);
  if (s < 60) return 'just now';
  const m = s / 60; if (m < 60) return Math.floor(m) + ' min ago';
  const h = m / 60; if (h < 24) return Math.floor(h) + ' h ago';
  const d = h / 24; if (d < 7) return Math.floor(d) + ' d ago';
  const w = d / 7; if (w < 5) return Math.floor(w) + ' w ago';
  const mo = d / 30; if (mo < 12) return Math.floor(mo) + ' mo ago';
  return Math.floor(d / 365) + ' y ago';
}
